var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.817,
    height: 18.072,
    viewBox: "0 0 25.817 18.072",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_156",
    "data-name": "Group 156",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_154",
    "data-name": "Group 154"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    "data-name": "Path 337",
    d: "M236.6,736.266a5.62,5.62,0,0,0-5.62-5.62H216.4a5.621,5.621,0,0,0-5.62,5.62V743.1a5.62,5.62,0,0,0,5.62,5.62h14.577a5.62,5.62,0,0,0,5.62-5.62Zm-9.2,3.76-5.813,3.188c-.253.137-.48-.046-.48-.333v-6.545c0-.291.234-.474.487-.329l5.853,3.356A.38.38,0,0,1,227.4,740.026Z",
    transform: "translate(-210.784 -730.646)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.e3932c51460358bafde15e046eca27fe.svg";
export { ForwardRef as ReactComponent };